import React, { useEffect, useMemo, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { collaboratorAPI } from '../utils/api';
import '../styles/CollaboratorAvailability.css';

const key = (date) => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');

const CollaboratorAvailability = () => {
  const { t, i18n } = useTranslation();
  const [slots, setSlots] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const range = useMemo(() => { const start = new Date(); start.setHours(0,0,0,0); const end = new Date(start); end.setMonth(end.getMonth() + 3); return { start, end }; }, []);

  useEffect(() => {
    collaboratorAPI.getAvailability().then(({ data }) => {
      setSlots(Object.fromEntries((data.availableSlots || []).map((slot) => [key(new Date(slot.date)), { ...slot }])));
    }).catch(() => toast.error(t('collaborator.loadError'))).finally(() => setLoading(false));
  }, [t]);

  const selectedKey = key(selectedDate);
  const selected = slots[selectedKey];
  const toggleDay = () => setSlots((current) => selected
    ? Object.fromEntries(Object.entries(current).filter(([date]) => date !== selectedKey))
    : { ...current, [selectedKey]: { date: `${selectedKey}T12:00:00`, isAvailable: true, startTime: '09:00', endTime: '17:00' } });
  const changeTime = (field, value) => setSlots((current) => ({ ...current, [selectedKey]: { ...current[selectedKey], [field]: value } }));
  const save = async () => {
    try {
      setSaving(true);
      await collaboratorAPI.updateAvailability(Object.values(slots));
      toast.success(t('collaborator.saved'));
    } catch (error) { toast.error(error.response?.data?.message || t('collaborator.saveError')); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="loading">{t('common.loading')}</div>;
  return <div className="collaborator-availability-page">
    <h1>{t('collaborator.title')}</h1>
    <p>{t('collaborator.instructions')}</p>
    <div className="collaborator-calendar-layout">
      <Calendar value={selectedDate} onChange={setSelectedDate} minDate={range.start} maxDate={range.end} locale={i18n.resolvedLanguage?.startsWith('fr') ? 'fr-CA' : 'en-CA'} tileClassName={({date,view}) => view === 'month' && slots[key(date)] ? 'collaborator-day-available' : null} />
      <section className="collaborator-day-editor">
        <h2>{selectedDate.toLocaleDateString(i18n.resolvedLanguage, { dateStyle: 'long' })}</h2>
        <button type="button" className={selected ? 'remove-day' : 'add-day'} onClick={toggleDay}>{selected ? t('collaborator.removeDay') : t('collaborator.addDay')}</button>
        {selected && <div className="collaborator-time-fields">
          <label>{t('admin.start')}<input type="time" step="1800" value={selected.startTime} onChange={(e) => changeTime('startTime', e.target.value)} /></label>
          <label>{t('admin.end')}<input type="time" step="1800" value={selected.endTime} onChange={(e) => changeTime('endTime', e.target.value)} /></label>
        </div>}
      </section>
    </div>
    <button type="button" className="save-collaborator-availability" onClick={save} disabled={saving}>{saving ? t('common.loading') : t('collaborator.save')}</button>
  </div>;
};

export default CollaboratorAvailability;
